import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  roles,
  rolesForm,
  alerts,
  alertsForm,
  currentTheme,
  zones,
  zonesForm,
  containers,
  containersForm,
  containermeasurements,
  containermeasurementsForm,
  hoteldatas,
  hoteldatasForm,
  hotelchains,
  hotelchainsForm,
  establishments,
  establishmentsForm,
  supports,
  supportsForm,
  zonecategories,
  zonecategoriesForm,
  wastetypes,
  wastetypesForm,
} from "./Reducers";

export default combineReducers({
  supports,
  supportsForm,
  zonecategories,
  zonecategoriesForm,
  wastetypes,
  wastetypesForm,
  establishments,
  establishmentsForm,
  hotelchains,
  hotelchainsForm,
  containermeasurements,
  containermeasurementsForm,
  hoteldatas,
  hoteldatasForm,
  containers,
  containersForm,
  zones,
  zonesForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  roles,
  rolesForm,
  alerts,
  alertsForm,
  currentTheme,
});
